// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdvertSidebarSticky_wrapper__ZdK2s","sticky":"AdvertSidebarSticky_sticky__921Mi"};